var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 px-4"},[_c('list-table',{ref:"listTable",attrs:{"columns":_vm.columns,"createButton":false,"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"identifier":"supplierOrdersWithIncomeForTodayTable","title":"Arrivage d'aujourd'hui"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }